import React from 'react';
import { useTranslation } from 'react-i18next';

const PaymentStatusTag = ({ status }) => {
  const { t } = useTranslation('DigitalPayments');

  const getStatusConfig = () => {
    switch (status) {
      case 'success':
        return {
          bgColor: 'tw-bg-green-50',
          textColor: 'tw-text-emerald-600',
          label: t('status.success')
        };
      case 'failed':
        return {
          bgColor: 'tw-bg-red-50',
          textColor: 'tw-text-red-600',
          label: t('status.failed')
        };
      case 'refunded':
        return {
          bgColor: 'tw-bg-blue-50',
          textColor: 'tw-text-blue-600',
          label: t('status.refunded')
        };
      case 'canceled':
        return {
          bgColor: 'tw-bg-red-50',
          textColor: 'tw-text-red-600',
          label: t('status.canceled')
        };
      case 'rejected':
        return {
          bgColor: 'tw-bg-red-50',
          textColor: 'tw-text-red-600',
          label: t('status.rejected')
        };
      default:
        return {
          bgColor: 'tw-bg-orange-50',
          textColor: 'tw-text-yellow-600',
          label: t('status.pending')
        };
    }
  };

  const config = getStatusConfig();

  const tagClasses = [
    'tw-inline-block',
    'tw-py-1',
    'tw-px-2',
    'tw-rounded-md',
    'tw-text-xs',
    'tw-font-medium',
    config.bgColor,
    config.textColor
  ].join(' ');

  return (
    <span className={tagClasses}>
      {config.label}
    </span>
  );
};

export default PaymentStatusTag;


